const LOAD_USER_CONTENTS = "user-contents::load-all::success";
const LOAD_USER_CONTENTS_FAILURE = "user-contents::load-all::failure";

const EDIT_USER_CONTENT = "user-content::edit";
const EDIT_USER_CONTENT_ERROR = "user-content::edit::error";
const EDIT_USER_CONTENT_SUCCESS = "user-content::edit::success";

const UPLOAD_USER_CONTENT = "user-content::upload";
const UPLOAD_USER_CONTENT_ERROR = "user-content::upload::error";
const UPLOAD_USER_CONTENT_SUCCESS = "user-content::upload::success";

const UPLOAD_USER_CONTENT_S3 = "user-content::upload::s3";

const ARCHIVE_USER_CONTENTS_SUCCESS = "user-content::archive::success";

function editUserContentAction(payload, successMessage = "") {
  const { id, duration, name, tag } = payload;
  return {
    payload: {
      successMessage,
      serviceArgs: [id, duration, name, tag],
    },
    type: EDIT_USER_CONTENT,
  };
}

function uploadUserContentAction(payload, successMessage = "") {
  return {
    payload: {
      serviceArgs: [payload],
      successMessage,
    },
    type: UPLOAD_USER_CONTENT,
  };
}

function uploadUserContentToS3Action(payload, successMessage = "") {
  const { duration, file, filename, folderId, name } = payload;
  return {
    payload: {
      serviceArgs: [file, filename, name, duration, folderId],
      successMessage,
    },
    type: UPLOAD_USER_CONTENT_S3,
  };
}

export {
  ARCHIVE_USER_CONTENTS_SUCCESS,
  LOAD_USER_CONTENTS,
  LOAD_USER_CONTENTS_FAILURE,
  EDIT_USER_CONTENT,
  EDIT_USER_CONTENT_ERROR,
  EDIT_USER_CONTENT_SUCCESS,
  UPLOAD_USER_CONTENT,
  UPLOAD_USER_CONTENT_ERROR,
  UPLOAD_USER_CONTENT_SUCCESS,
  UPLOAD_USER_CONTENT_S3,
  editUserContentAction,
  uploadUserContentAction,
  uploadUserContentToS3Action,
};
